<div class="eui-app-top-message__wrapper">
    <div class="eui-app-top-message__content">
        <ng-content></ng-content>
    </div>
    <span *ngIf="isCloseable" class="eui-app-top-message__close" role="button" aria-label="Close Icon Button"
         (click)="onCloseClick($event)">
    </span>
</div>
